import { resetFilter, saveFilter } from '@bells/i18n';
import { Button } from '../../components/button';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from '../../components/drawer';
import { ScrollArea } from '../../components/scroll-area';
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '../../components/sheet';
import { useMediaQuery } from '../../hooks/use-media-query';
import Filter from './filter';
import { useFilter } from './filter-provider';

export const AttendantSidebarDesktopFilter = () => {
  const { showFilter, setShowFilter } = useFilter();
  const { totalFilters, reset } = useFilter();

  return (
    <Sheet open={showFilter} onOpenChange={setShowFilter}>
      <SheetContent className='flex h-full flex-col p-0'>
        <SheetHeader className='p-4'>
          <SheetTitle>Filter</SheetTitle>
        </SheetHeader>

        <div className='h-full flex-1 overflow-auto p-4 py-0'>
          <Filter></Filter>
        </div>
        <SheetFooter className='border-t p-4'>
          <SheetClose asChild>
            <Button>{saveFilter()}</Button>
          </SheetClose>
          <Button
            onClick={() => {
              reset();
              setShowFilter(false);
            }}
            disabled={totalFilters <= 0}
            variant='outline'
          >
            {resetFilter()}
            {totalFilters > 0 && <span>({totalFilters})</span>}
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};

export const AttendantSidebarMobileFilter = () => {
  const { showFilter, setShowFilter } = useFilter();
  const { totalFilters, reset } = useFilter();

  return (
    <Drawer open={showFilter} onOpenChange={setShowFilter}>
      <DrawerContent className='mx-auto h-full max-h-[90vh] max-w-screen-sm'>
        <DrawerHeader>
          <DrawerTitle>Filter</DrawerTitle>
        </DrawerHeader>
        <ScrollArea type='auto'>
          <div className='space-y-2 px-2'>
            <Filter></Filter>
          </div>
        </ScrollArea>

        <DrawerFooter>
          <DrawerClose asChild>
            <Button>{saveFilter()}</Button>
          </DrawerClose>

          <Button
            onClick={() => {
              reset();
              setShowFilter(false);
            }}
            disabled={totalFilters <= 0}
            variant='outline'
          >
            {resetFilter()}
            {totalFilters > 0 && <span>({totalFilters})</span>}
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default function AttendantSidebarFilter() {
  const isDesktop = useMediaQuery('(min-width: 768px)');

  if (isDesktop) {
    return <AttendantSidebarDesktopFilter></AttendantSidebarDesktopFilter>;
  }
  return <AttendantSidebarMobileFilter></AttendantSidebarMobileFilter>;
}
